import * as React from 'react';

import { RegisterFormProvider } from './RegisterForm.context';
import { RegisterFormStep1 } from './RegisterForm.step1';
import { RegisterFormStep2 } from './RegisterForm.step2';
import { RegisterFormStep3 } from './RegisterForm.step3';
import { RegisterShell } from './RegisterShell';

interface Props {
  accountCategories?: any[];
  token?: string;
  registerAssets?: {logo?: string};
}

function RegisterForm({registerAssets, ...props}: Props) {
  return (
    <RegisterFormProvider {...props}>
      <RegisterShell logoUrl={registerAssets?.logo}>
        <RegisterFormStep1 />
        <RegisterFormStep2 />
        <RegisterFormStep3 />
      </RegisterShell>
    </RegisterFormProvider>
  );
}

export default RegisterForm;
